import { requestMethod } from "../../config";
import config from "../../env.config";
import { checkApiSuccess } from "../../utils";
import { fetch } from "./api.service";

const EDITOR_URL = `${config.BASE_URL.COLLAB_URL}/collab-editor`;
const EDITOR_ENDPOINTS = {
  DESC_EXISTS: "desc-exists",
  VERSION_HISTORY: "version-history",
  PREVIEW_VERSION: "preview-version",
  CREATE_MANUAL_VERSION: "create-version",
  RESTORE_VERSION: "restore-version",
};

/**
 * API to fetch version history list for a document
 * @param {string | number} docId
 * @author Abhishek Dhillon
 */
export const getVersionHistory = async (docId) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${EDITOR_URL}/${EDITOR_ENDPOINTS.VERSION_HISTORY}/${docId}`,
  };
  let response = await fetch(requestConfig, false, true);
  return response?.data;
};

/**
 * API to fetch a selected version preview
 * @param {string} versionId
 * @author Abhishek Dhillon
 */
export const getPreviewVersion = async (versionId) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${EDITOR_URL}/${EDITOR_ENDPOINTS.PREVIEW_VERSION}/${versionId}`,
  };
  let response = await fetch(requestConfig, false, true);
  return response?.data;
};

/**
 * API to create a manual version for a document
 * @param {{docId: string, username: string}} payload
 * @author Abhishek Dhillon
 */
export const createManualVersion = async (payload) => {
  let requestConfig = {
    method: requestMethod.POST,
    url: `${EDITOR_URL}/${EDITOR_ENDPOINTS.CREATE_MANUAL_VERSION}`,
    data: payload,
  };
  let response = await fetch(requestConfig, false, true);
  return response?.data;
};

/**
 * API to restore a selected version
 * @param {{versionId: string}} payload
 * @author Abhishek Dhillon
 */
export const restoreManualVersion = async (payload) => {
  let requestConfig = {
    method: requestMethod.POST,
    url: `${EDITOR_URL}/${EDITOR_ENDPOINTS.RESTORE_VERSION}`,
    data: payload,
  };
  let response = await fetch(requestConfig, false, true);
  return response?.data;
};
